/* eslint-disable no-console */
import { createSlice } from "@reduxjs/toolkit";
import axios from "src/utils/axios";
// import URLs from 'src/URL.json'
import { changeState, getvdiInfo, set360view } from "./editor";
import { resourceInfo, setActiveTab } from "./AvToolbar";
import { storeAccessActiveMachine } from "./persistStore";
import { VdiServiceActions } from "./events/Resource_Assignment";
import { findMachineName, handleTabMachine } from "src/constants/commonFuntion";
import store from "src/store";

enum ECOLOR {
  ERROR = "error",
  INFO = "info",
}

interface IAccess {
  name: string;
  device: string;
  ip: string;
  access: string;
  os: string;
  address: string;
}

interface IRoot {
  snack: {
    active: boolean;
    message: string;
  };
  notifySnack: {
    active: boolean;
    color: ECOLOR;
    message: string;
  };
  accessDialog: {
    active: boolean;
    access: IAccess[];
  };
  lifecycleDialog: {
    active: boolean;
    access: IAccess[];
    message?: string;
  };
  autoAccessMsg: {
    active: boolean;
    message: string;
  };
  eventDeleted: boolean;
  vdiProgressDialog: {
    active: boolean;
    serviceId: string;
    stage: string;
    stages: string[];
    mode: "start" | "archive" | "retrieve" | "upgrade" | "error" | "credits_limit";
    os: string;
    timeoutDuration: number | null;
  };
}

const initialState: IRoot = {
  snack: {
    active: false,
    message: "",
  },
  notifySnack: {
    active: false,
    color: ECOLOR.INFO,
    message: "",
  },
  accessDialog: {
    active: false,
    access: [],
  },
  lifecycleDialog: {
    active: false,
    access: [],
    message: "",
  },
  autoAccessMsg: {
    active: false,
    message: "",
  },
  eventDeleted: false,
  vdiProgressDialog: {
    active: false,
    serviceId: "",
    stage: "",
    stages: [],
    mode: "start",
    os: "",
    timeoutDuration: null,
  },
};

const slice = createSlice({
  name: "oprations",
  initialState,
  reducers: {
    snakMsg(state, action) {
      state.snack = action.payload;
    },
    notifySnakMsg(state, action) {
      state.notifySnack = action.payload;
    },
    setAccessVDIDialog(state, action) {
      state.accessDialog = action.payload;
    },
    setLifecycleDialog(state, action) {
      state.lifecycleDialog = action.payload;
    },
    autoAccessSnakMsg(state, action) {
      state.autoAccessMsg = action.payload;
    },
    setEventDeleted(state, action) {
      state.eventDeleted = action.payload;
    },
    setVdiProgressStage(state, action) {
      const { serviceId, stage, mode, os } = action.payload;
      state.vdiProgressDialog.active = true;
      state.vdiProgressDialog.serviceId = serviceId;
      state.vdiProgressDialog.stage = stage;
      state.vdiProgressDialog.mode = mode ?? "start";
      if (os) state.vdiProgressDialog.os = os;
      if (!state.vdiProgressDialog.stages.includes(stage)) {
        state.vdiProgressDialog.stages.push(stage);
      }
    },
    clearVdiProgressDialog(state) {
      state.vdiProgressDialog = {
        active: false,
        serviceId: "",
        stage: "",
        stages: [],
        mode: "start",
        os: "",
        timeoutDuration: null,
      };
    },
    setVdiKickTimeout(state, action) {
      state.vdiProgressDialog.timeoutDuration = action.payload;
    },
  },
});

export const { setVdiKickTimeout, clearVdiProgressDialog, setVdiProgressStage, setEventDeleted, autoAccessSnakMsg, setLifecycleDialog, setAccessVDIDialog, notifySnakMsg, snakMsg } = slice.actions;
export const reducer = slice.reducer;
const BASE_URL = process.env.REACT_APP_API_URL;

const LINK = `${process.env.REACT_APP_API_URL}/service-management/api/v1`;

export const oprations = (data, enqueueSnackbar) => async (dispatch) => {
  try {
    const newValue = [];
    const body = {
      type: "virtual_desktop_infrastructure_browser",
      process: data.action,
      serviceId: data.serviceId,
    };
    newValue.push(body);
    const response = await axios.post(
      `${BASE_URL}/service-management/api/v1/service`,
      newValue,
    );
    if (response?.status === 200) {
      if (response?.data?.data && Array.isArray(response.data.data)) {
        response.data.data.forEach((res) => {
          if (res.status === false) {
            enqueueSnackbar("Failed to perform requested operation", {
              variant: "error",
              preventDuplicate: true,
              autoHideDuration: 5000,
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
              },
            });
          } else {
            dispatch(
              slice.actions.snakMsg({ active: true, message: response?.data?.message || "Operation successful" })
            );
            setTimeout(() => {
              dispatch(slice.actions.snakMsg({ active: false, message: "" }));
            }, 3000);
          }
        });
      } else {
        dispatch(
          slice.actions.snakMsg({ active: true, message: response?.data?.message })
        );
        setTimeout(() => {
          dispatch(slice.actions.snakMsg({ active: false, message: "" }));
        }, 3000);
      }
    }
  } catch (error) {
    throw new Error(error);
  } finally {
    // for archival
    dispatch(VdiServiceActions.resetMachineArchivalData());
  }
};

export const oprationsMulti = (data, value, enqueueSnackbar) => async () => {
  try {
    const payload = data.map(id => ({
      type: "virtual_desktop_infrastructure_browser",
      process: value,
      serviceId: id,
    }));
    const res = await axios.post(
      `${BASE_URL}/service-management/api/v1/service`,
      payload,
    );
    
    if (res?.status && res?.data?.status) {
      enqueueSnackbar(res?.data?.message, {
        variant: "success",
        preventDuplicate: true,
        autoHideDuration: 5000,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      });
    } else {
      enqueueSnackbar(res?.data?.message || "Failed to perform requested operation", {
        variant: "error",
        preventDuplicate: true,
        autoHideDuration: 5000,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      });
    }
  } catch (error) {
    enqueueSnackbar(
      error?.message || error || "Failed to perform requested operation",
      {
        variant: "error",
        preventDuplicate: true,
        autoHideDuration: 5000,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      }
    );
    throw new Error(error);
  }
};

export const setSnackMSG = (data) => (dispatch) => {
  dispatch(slice.actions.snakMsg(data));
};

export const notifyParticipants = (data) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/events/api/v1/participants/notify?id=${data}`
    );
    if (response?.data?.status) {
      dispatch(
        slice.actions.notifySnakMsg({
          active: true,
          color: ECOLOR?.INFO,
          message: response?.data?.data,
        })
      );
    } else {
      dispatch(
        slice.actions.notifySnakMsg({
          active: true,
          color: ECOLOR?.ERROR,
          message: response?.data?.message,
        })
      );
    }
    setTimeout(() => {
      dispatch(
        slice.actions.notifySnakMsg({
          active: false,
          color: ECOLOR?.INFO,
          message: "",
        })
      );
    }, 3000);
  } catch (error) {
    throw new Error(error);
  }
};

export const lockParticipants = (data) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/events/api/v1/participants/${data}/lock`
    );
    if (response?.data?.status) {
      dispatch(
        slice.actions.notifySnakMsg({
          active: true,
          color: ECOLOR?.INFO,
          message: response?.data?.data,
        })
      );
    } else {
      dispatch(
        slice.actions.notifySnakMsg({
          active: true,
          color: ECOLOR?.ERROR,
          message: response?.data?.message,
        })
      );
    }
    setTimeout(() => {
      dispatch(
        slice.actions.notifySnakMsg({
          active: false,
          color: ECOLOR?.INFO,
          message: "",
        })
      );
    }, 3000);
  } catch (error) {
    throw new Error(error);
  }
};

export const notifySnackMSG = (data) => async (dispatch) => {
  if (data) {
    const filterItem = data?.response?.data?.access?.map(
      async (value) =>
        new Promise((resolve) => {
          async function apiHit() {
            if (value?.access !== "host") {
              const response = await axios.get(
                `${LINK}/service?id=${value?.device}`
              );
              if (response?.data?.status) {
                resolve({
                  name: value?.name,
                  ip: response?.data?.data[0]?.dns?.ip,
                  access: value?.access,
                  device: value?.device,
                  os: response?.data?.data[0]?.properties?.os,
                  address: response?.data?.data[0]?.dns?.address,
                });
              } else {
                resolve("");
              }
            } else {
              resolve("");
            }
          }
          apiHit();
        })
    );

    Promise.all(filterItem).then((value) => {
      dispatch(
        slice.actions.setAccessVDIDialog({
          active: true,
          access: value.filter((value) => value !== ""),
        })
      );
    });
  }
}; export const notifyAccessVDIDialog = (data) => async (dispatch, getState) => {
  if (data) {
    const currentParticipantId = getState().messages.user_id;
    const serviceId = data.response.data.serviceId;
    const serviceName = data.response.data.serviceName;
    try {
      const response = await axios.get(`${LINK}/service?id=${serviceId}`);
      if (response?.data?.status) {
        const serviceData = response.data.data[0];
        const userAccess = serviceData.access?.filter((value) => {
          return value.access !== "host";
        }).find(acc => acc.participant_id === currentParticipantId);
        if (userAccess) {
          dispatch(slice.actions.setLifecycleDialog({
            active: true,
            access: [{
              name: serviceName,
              device: serviceId,
              ip: serviceData?.dns?.ip,
              access: userAccess.access,
              os: serviceData?.properties?.os,
              address: serviceData?.dns?.address,
            }]
          }));
        }
      }
    } catch (error) {
      console.error("Failed to fetch service details for LIFECYCLE_UPDATE", error);
    }
    return;
  }
};

export const notifyAccessGrantedDialog = (data) => async (dispatch, getState) => {
  const eventType = getState().AVSetting.eventType;
  if (eventType !== "playbook") return;
  if (data && data?.response?.data?.action === "ACCESS_GRANTED") {
    const currentParticipantId = getState().messages.user_id;
    const serviceId = data?.response?.data?.serviceId;
    const customMessage = data?.response?.data?.message || "";
    try {
      const response = await axios.get(`${LINK}/service?id=${serviceId}`);
      if (response?.data?.status) {
        const serviceData = response.data.data[0];
        const serviceName = serviceData?.name || serviceId;
        const userAccess = serviceData.access?.filter((value) => {
          return value.access !== "host";
        }).find(acc => acc.participant_id === currentParticipantId);
        if (userAccess) {
          dispatch(slice.actions.setLifecycleDialog({
            active: true,
            message: customMessage,
            access: [{
              name: serviceName,
              device: serviceId,
              ip: serviceData?.dns?.ip,
              access: userAccess.access,
              os: serviceData?.properties?.os,
              address: serviceData?.dns?.address,
            }]
          }));
        }
      }
    } catch (error) {
      console.error("Failed to fetch service details", error);
    }
  }
};

export const clearDialog = () => async (dispatch) => {
  dispatch(slice.actions.setAccessVDIDialog({ active: false, access: [] }));
  dispatch(slice.actions.setLifecycleDialog({ active: false, access: [], message: "" }));
};

export const notifyVdiProgressStage = (data: { serviceId: string; stage: string; mode?: string, os?: string }) => async (dispatch, getState) => {
  const currentOs = getState().oprations.vdiProgressDialog.os;
  if (!currentOs && data.serviceId) {
    try {
      const response = await axios.get(`${LINK}/service?id=${data.serviceId}`);
      if (response?.data?.status) {
        const os = response.data.data[0]?.properties?.os || "windows";
        dispatch(slice.actions.setVdiProgressStage({ ...data, os }));
        return;
      }
    } catch (e) {
      //
    }
  }

  if (currentOs && !data.os) {
    data.os = currentOs;
  }

  dispatch(slice.actions.setVdiProgressStage(data));
};

export const clearVdiProgress = () => (dispatch) => {
  dispatch(slice.actions.clearVdiProgressDialog());
};

export const autoUpdate = (data) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/events/api/v1/participants/autoAccess`,
      { participants: data }
    );
    if (response?.data?.status) {
      dispatch(
        slice.actions.notifySnakMsg({
          active: true,
          color: ECOLOR?.INFO,
          message: response?.data?.data,
        })
      );
    } else {
      dispatch(
        slice.actions.notifySnakMsg({
          active: true,
          color: ECOLOR?.ERROR,
          message: response?.data?.message,
        })
      );
    }
    setTimeout(() => {
      dispatch(
        slice.actions.notifySnakMsg({
          active: false,
          color: ECOLOR?.INFO,
          message: "",
        })
      );
    }, 3000);
  } catch (error) {
    throw new Error(error);
  }
};

export const getAutoAccessId = () => async (dispatch) => {
  try {
    const response = await axios.get(`${BASE_URL}/events/api/v1/participants/auto_access`);
    if (response?.data?.status) {
      const data = response?.data?.data;
      dispatch(autoUpdate(data));
    }
  } catch (error) {
    throw new Error(error);
  }
};
export const handleAutoAccessSelectedMachine = (data, name, pc, enqueueSnackbar) => async () => {
  try {
    const response = await axios.post(`${BASE_URL}/events/api/v1/participants/autoAccess/specific`, data);
    if (!response?.data?.status) {
      throw new Error(response?.data?.message || `${name} could not access ${pc}`);
    }

    enqueueSnackbar(`${name} is accessing ${pc}`,
      {
        variant: "success",
        preventDuplicate: true,
        autoHideDuration: 5000,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      }
    );
  } catch (error) {
    enqueueSnackbar(
      error?.message || error || `${name} could not access ${pc}`,
      {
        variant: "error",
        preventDuplicate: true,
        autoHideDuration: 5000,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      }
    );
  }
};

// Handle add vdi tab when machine is getting accessed
const handleAccessAddVdiTab = (id, currentTime) => {
  const newName = "Machine (" + findMachineName(id) + ")";
  const newTab = {
    type: "Machine",
    name: newName,
    active: false,
    lastActiveTime: currentTime,
    documentId: "",
  };
  handleTabMachine(newTab);
  store.dispatch(setActiveTab(newName));
};

export const autoAccessSetVDI = (data, activeMachine) => async (dispatch) => {
  try {
    const value = data?.response?.data?.access?.filter(
      (val) => val?.access === "owner"
    );
    if (value?.length > 0) {
      const response = await axios.get(`${LINK}/service?id=${value[0].device}`);
      if (response?.data?.status) {
        if (activeMachine?.length === 0) {
          const currentTime = new Date().toString();
          dispatch(changeState(false));
          dispatch(set360view(false));
          dispatch(
            getvdiInfo({
              device: value[0]?.device,
              access: value[0]?.access,
              ip: response?.data?.data[0]?.dns?.ip,
              os: response?.data?.data[0]?.properties?.os,
              address: response?.data?.data[0]?.dns?.address,
            })
          );

          dispatch(
            storeAccessActiveMachine({
              deviceId: value[0]?.device,
              ipAddress: response?.data?.data[0]?.dns?.ip,
              accessType: value[0]?.access,
              os: response?.data?.data[0]?.properties?.os,
              address: response?.data?.data[0]?.dns?.address,
              lastActiveTime: currentTime,
            })
          );
          handleAccessAddVdiTab(value[0]?.device, currentTime);
          dispatch(resourceInfo(false));
          dispatch(changeState(true));

          dispatch(
            slice.actions.autoAccessSnakMsg({
              active: true,
              message: "Trainer force for Machine Access",
            })
          );
          setTimeout(() => {
            dispatch(
              slice.actions.autoAccessSnakMsg({ active: false, message: "" })
            );
          }, 3000);
        }
      }
    }
  } catch (error) {
    throw new Error(error);
  }
};

const bulkMachineOperations = async (groupId: string, process: 'start' | 'stop', enqueueSnackbar: any) => {
  try {
    enqueueSnackbar(`Initiating ${process} for all assigned machines...`, {
      variant: "info",
      preventDuplicate: true,
      autoHideDuration: 3000,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
    });

    const response = await axios.post(
      `${LINK}/service/bulk-operation`,
      { groupId, process }
    );

    if (response?.data?.status) {
      const { successful, total, results } = response.data.data;

      enqueueSnackbar(
        `Successfully ${process === 'start' ? 'started' : 'stopped'} ${successful} of ${total} assigned machines`,
        {
          variant: "success",
          preventDuplicate: true,
          autoHideDuration: 5000,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        }
      );

      // Log any failures for debugging
      const failures = results?.filter((r) => !r.status);
      if (failures && failures.length > 0) {
        console.warn(`Failed to ${process} some machines:`, failures);
      }
    } else {
      throw new Error(response?.data?.message || `Bulk ${process} operation failed`);
    }
  } catch (error: any) {
    console.error(`Bulk ${process} failed:`, error);
    enqueueSnackbar(
      error?.response?.data?.message || error?.message || `Failed to ${process} assigned machines`,
      {
        variant: "error",
        preventDuplicate: true,
        autoHideDuration: 5000,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      }
    );
  }
};

export const bulkStartAssignedMachines = (groupId: string, enqueueSnackbar: any) => async () => {
  await bulkMachineOperations(groupId, 'start', enqueueSnackbar);
};

export const bulkStopAssignedMachines = (groupId: string, enqueueSnackbar: any) => async () => {
  await bulkMachineOperations(groupId, 'stop', enqueueSnackbar);
};

export const EventDeleted = (data) => (dispatch) => {
  dispatch(slice.actions.setEventDeleted(data));
};
export default slice;
